import regex from '@src/constants/regex';

export const formatDefaultString = (string = '') => {
  const value = (string || '').toString().replace(regex.empty, '');
  return value;
};
